<template>
    <div class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit('ruleForm')"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
             <el-form-item label="新闻名称：" prop="title">
                    <el-input v-model="form.title" placeholder="请输入新闻名称" clearable></el-input>
                </el-form-item>
                    <el-form-item label="选择关联分类：" prop="class">
                        <el-checkbox-group v-model="checkList" @change="classSelectType">
                  <el-checkbox label="1">和隆优化官网</el-checkbox>
                  <el-checkbox label="2">和隆软件官网</el-checkbox>
              </el-checkbox-group>
                    <el-select v-model="form.class" placeholder="选择关联分类">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                       <el-form-item label="新闻封面图：" prop="pic">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    :before-upload="$util.beforeUpload"
                    :on-error="upLoaderror"
                    >
                    <img :src="form.pic" class="avatar" v-if="form.pic">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.pic" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.pic" alt="">
                    </el-dialog>
                    </el-upload>
                    <div>建议大小：1920*396px 最大限制5M，支持JPG，PNG格式上传</div>
                 </el-form-item>
                  <el-form-item label="新闻排序：">
                    <el-input v-model="form.sort" placeholder="请输入新闻排序" clearable></el-input>
                </el-form-item>
                 <el-form-item label="新闻详情：" prop="type">
                <el-radio v-model="form.type" label="1" >编辑器录入</el-radio>
                <el-radio v-model="form.type" label="2">外部链接</el-radio>
              </el-form-item>
                <el-form-item label="新闻详情链接："  prop="link" class="Flex-w" v-if="form.type == 2">
                    <el-input v-model="form.link" placeholder="注意：链接需加前缀http://或https://，否则会跳转错误" clearable></el-input>
                </el-form-item>
         </el-form>
               <div class="AppContent" v-if="form.type == 1">
                  <div class="moreCanvas"
                    >
                     <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 新闻内容
                        </div>
                    </div> 
                      <quillsTemplate  @sendStatus="emitFun" :propData="contentHtml"
                      :noneboo="false"
                        ref='quillTemplate'
                    ></quillsTemplate>
                  </div>
               </div>
             </div>
    </div>
</template>
<script>
import LocaStorage from "../../../../utils/localstorage.js" //本地存储公共方法
import CropperImage from "@/components/CropperImage.vue";  //裁剪组件
import quillsTemplate from "@/components/quill/index.vue";  //多富文本组件
import { editNews,newsClassify,getNews} from "@/api/index/index"  //新增修改解决方案列表、新闻分类、解决方案详情
export default {
    name:'addSolution',
     components: {
        CropperImage,
        quillsTemplate
    },
    data() {
        return {
            checkList:[],
            uploadBoolean:false,
            oploadDialogVisible: false,
            headers:{},
            nowIndex:0,
            platformAppContentList:[],
            options:[],
             loading:false,
            cropperModel:false,
            cropperName:'',
            edittext:'保存',
            contentHtml:'',
            form:{
                title:'',
                class:'',
                pic:'',
                sort:'',
                type:'1',
                link:''
            },
            rules:{
            title: [{ required: true, message: '请输入新闻名称', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
              class: [{ required: true, message: '请选择关联分类', trigger: 'change' },],
            pic: [{ required: true, message: '请上传新闻封面图', trigger: 'blur' }],
             title: [{ required: true, message: '请输入新闻名称', trigger: 'blur' }],
             type: [{ required: true, message: '请选择详情类型', trigger: 'change' }],
              link: [{ required: true, message: '请输入新闻详情链接', trigger: 'blur' }],
              
            }
        }
    },
    created() {
    let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        this.getDetail()
    },
    methods: {
             classSelectType(){
           let checkStr = this.checkList.join(',')
           let num = ['1,2', '2,1'].includes(checkStr);
              let officialType = ''
               num ? officialType = "" : officialType = checkStr
               num ? officialType = "" : officialType = checkStr
              this.getNewsClassify(officialType)
      }, 
              // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                this.form.pic = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
         handleAvatarSuccess(res, file) {
        this.form.pic = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
    //   图片上传失败钩子
        upLoaderror(err){
            this.$message.error('图片上传失败')
        },
         // 分类列表
      getNewsClassify(num){
         newsClassify({
             name:'',
            officialType:num
         })
         .then(res =>{
          if(res.code == 0){
            this.options = res.data
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
          }
         })
         .catch(err =>{})
      },
       // 获取详情
        getDetail(){
            getNews(
                {id:this.$route.query.id},
                'get')
             .then(res => {
                this.form = {
                    title:res.data.name,
                    class:res.data.classifyId,
                    pic:res.data.pic,
                    sort:res.data.sort,
                    type:res.data.type,
                    link:''
                }
                res.data.type == 2 ? this.form.link = res.data.content : this.contentHtml = res.data.content
                    let num = ['1,2', '2,1'].includes(res.data.officialType);
              let officialType = ''
               num ? officialType = "" : officialType = res.data.officialType
               num ? officialType = "" : officialType = res.data.officialType
              this.getNewsClassify(officialType)
              this.checkList = res.data.officialType.split(',')
             })
             .catch(err => {})
        },
        // 提交
        onSubmit(formName){
             let params = {
                name:this.form.title,
                classifyId:this.form.class,
                pic:this.form.pic,
                sort:this.form.sort,
                type:this.form.type,
                content:this.form.type==2 ? this.form.link : this.contentHtml
            }
            let method = "post"
            if(!this.$route.query.id) params = {...params},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id},method = "put";
             this.$refs[formName].validate((valid) => { 
                if(valid){
                     this.commentBness(params,method)
                }
              })
        },
           commentBness(params,method){
               this.loading = true
                editNews(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          
                                setTimeout(() => {
                           this.$router.push("/News")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
           // 子组件触发的方法
        emitFun(val,index){
            this.contentHtml = val
        },
        // 返回
        reback(){
            this.$router.push('/News')
        },
    },
}
</script>
<style lang="scss" scoped>
 .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }
         }
              .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
           ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>